import React from 'react';
import classNames from 'classnames';

import Button from 'buttons/button';
import Icon from 'icons/icon';

import styles from './icon-button.less';

class IconButton extends React.Component {
  static propTypes = {
    icon: React.PropTypes.string.isRequired
  }

  render() {
    return (
    <Button {...this.props}>
      <Icon icon={this.props.icon} className={styles.icon} /> {this.props.children}
    </Button>
    );
  }
};

module.exports = IconButton;



/** WEBPACK FOOTER **
 ** ./src/buttons/icon-button/index.js
 **/